import styled from '@emotion/styled';
import {mixinOverflow} from 'webapp-lib/styling';

export const FormColumnWrapper = styled.div`
  display: flex;
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  gap: var(--gutter-small);
  overflow: hidden;
  /* Needed to show active border, gets otherwise cut out by overflow hidden*/
  padding: 0px var(--gutter-very-tiny);

  :not(:last-of-type) {
    margin-right: var(--gutter-big);
  }

  .FolderTreeWrapper {
    max-height: 320px;
    ${mixinOverflow}
  }
`;

export const FoldertreeColumn = styled.div`
  overflow: auto;
`;
